/**
 * Das Tiefenprofil als Zeilen-Glyph — das Erkennungszeichen der Liste.
 *
 * Ein Wandtauchgang, ein Strömungstauchgang und ein Checkdive haben
 * unterschiedliche Formen. Wer 995 Tauchgaenge durchsieht, erkennt sie an der
 * Silhouette schneller als an der Zahl daneben. Gezeichnet wird nach unten,
 * weil Tiefe nach unten zaehlt.
 *
 * Fuer die 657 Tauchgaenge ohne Profil steht eine einzelne Marke auf
 * Maximaltiefe: Die Achse bleibt lesbar, und es entsteht nicht der Eindruck,
 * dort waere nichts gewesen.
 */

import { tiefenfarbe, tiefenverlauf } from './tiefenfarbe.js';

/** Auf wenige Punkte eindampfen — mehr als die Glyphbreite braucht niemand. */
export function verdichte(messpunkte, ziel = 64) {
  if (!Array.isArray(messpunkte) || messpunkte.length === 0) return [];
  if (messpunkte.length <= ziel) return messpunkte.map((p) => p[1] ?? 0);
  const schritt = messpunkte.length / ziel;
  const werte = [];
  for (let i = 0; i < ziel; i += 1) {
    const von = Math.floor(i * schritt);
    const bis = Math.floor((i + 1) * schritt);
    let tiefste = 0;
    for (let j = von; j < bis; j += 1) {
      const wert = messpunkte[j][1] ?? 0;
      if (wert > tiefste) tiefste = wert;   // die tiefste Stelle des Abschnitts gewinnt
    }
    werte.push(tiefste);
  }
  return werte;
}

export function zeichne(leinwand, messpunkte, maxTiefe) {
  const ctx = leinwand.getContext('2d');
  const dichte = globalThis.devicePixelRatio || 1;
  const breite = leinwand.clientWidth || 72;
  const hoehe = leinwand.clientHeight || 40;
  leinwand.width = breite * dichte;
  leinwand.height = hoehe * dichte;
  ctx.scale(dichte, dichte);
  ctx.clearRect(0, 0, breite, hoehe);

  const tiefstes = Math.max(maxTiefe || 0, 1);
  const werte = verdichte(messpunkte, Math.floor(breite));

  if (werte.length === 0) {
    // Ohne Profil: eine Marke auf Maximaltiefe.
    const y = Math.min(hoehe - 1, (maxTiefe / tiefstes) * (hoehe - 2) + 1);
    ctx.strokeStyle = tiefenfarbe(maxTiefe);
    ctx.globalAlpha = 0.55;
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    ctx.moveTo(2, y);
    ctx.lineTo(breite - 2, y);
    ctx.stroke();
    ctx.globalAlpha = 1;
    return;
  }

  const x = (i) => (i / (werte.length - 1 || 1)) * breite;
  const y = (wert) => (wert / tiefstes) * (hoehe - 2) + 1;

  ctx.beginPath();
  ctx.moveTo(0, 0);
  werte.forEach((wert, i) => ctx.lineTo(x(i), y(wert)));
  ctx.lineTo(breite, 0);
  ctx.closePath();
  ctx.globalAlpha = 0.28;
  ctx.fillStyle = tiefenverlauf(ctx, hoehe, tiefstes);
  ctx.fill();

  ctx.globalAlpha = 1;
  ctx.beginPath();
  werte.forEach((wert, i) => (i ? ctx.lineTo(x(i), y(wert)) : ctx.moveTo(x(i), y(wert))));
  ctx.lineWidth = 1.25;
  ctx.strokeStyle = tiefenverlauf(ctx, hoehe, tiefstes);
  ctx.stroke();
}
